import React from "react";
import { useTranslation } from "react-i18next";
import BrandButton from "@/components/ui/BrandButton";
import { showApiError, showSuccess } from "@/utils";

const ExportButton = ({ contentDraft }) => {
  const { t } = useTranslation();
  const handleExport = () => {
    navigator.clipboard
      .writeText(contentDraft)
      .then(() => {
        showSuccess(t("common.copied", "Content draft copied to clipboard!"));
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        showApiError(t("common.copyFailed", "Failed to copy to clipboard."));
      });
  };

  return (
    <div className="d-flex justify-content-center pt-3">
      <div className="text-center">
        <BrandButton
          className="bg-brand-gradient"
          onClick={handleExport}
          dataTestId="export-draft-button"
        >
          {t("contentOptimizer.exportDraft", "Export Draft")}
        </BrandButton>
        <p className="rs-export-note text-muted mt-2">
          {t("contentOptimizer.exportsToRtf", "Exports to RTF (.rtf)")}
        </p>
      </div>
    </div>
  );
};

export default ExportButton;
